import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { Button, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import styles from './style';

const EirLoader = props => {
  const theme = useTheme();
  return (
    <Box>
      <Button
        variant='buttonMedium'
        sx={{
          ...styles(theme).loaderButton,
          ...props.buttonSize,
        }}
        loadingIndicator={props.loaderTitle}
      >
        <Stack
          direction='row'
          alignItem='center'
          justifyContent='center'
          spacing={1}
          sx={props?.padding}
        >
          <CircularProgress
            disableShrink
            sx={{
              color: theme.palette.secondary.contrastText,
              mt: '3px',
            }}
            size={props.loaderSpinnerSize ? props.loaderSpinnerSize : 17}
            thickness={6}
          />
          <Typography
            variant='subtitle1'
            sx={{
              ...styles(theme).loaderText,
              ...props.buttonTextSize,
            }}
          >
            {props.loaderTitle}...{' '}
          </Typography>
        </Stack>
      </Button>
    </Box>
  );
};

export default EirLoader;
